'use client';
import dynamic from 'next/dynamic';
import React from 'react';

const ENABLE_INTERCOM = process.env.NEXT_PUBLIC_ENABLE_INTERCOM;
const INTERCOM_APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID as string;

const DynamicIntercomLoaderImplementation = dynamic(
  () => import('./IntercomLoader'),
  {
    ssr: false,
  },
);

export const DynamicIntercomLoader: React.FC = () => {
  return (
    <DynamicIntercomLoaderImplementation
      enableIntercom={ENABLE_INTERCOM === 'true'}
      intercomAppid={INTERCOM_APP_ID}
    />
  );
};
